const vehicles = () => {

    const btnOpenFilter = document.querySelector('.btn-event-filter');
    const formFilter = document.querySelector('.catalog-filter');


    if (btnOpenFilter && formFilter) {

        btnOpenFilter.addEventListener('click', function (evt) {
            evt.preventDefault();
            if (formFilter.classList.contains('is-active')) {
                formFilter.classList.remove('is-active');
            } else {
                formFilter.classList.add('is-active');
            }

        })

    }

}

export {vehicles}
